import { IAAPServerPlanPayloadBase } from "../models/IMediaToolkit";

export async function GetDataFromServer<T>(payload: IAAPServerPlanPayloadBase): Promise<T> {
    return new Promise((resolve, reject) => {
        try {
            WebForm_DoCallback(
                "FamilyMediaPlanControl",
                JSON.stringify(payload),
                (response: string) => {
                    try {
                        const parsed = JSON.parse(response);
                        resolve(parsed);
                    } catch (er) {
                        reject(response);
                    }
                },
                "",
                (failResponse: string) => reject(failResponse),
                true,
                `?api=${payload.type}`
            ).catch((er) => reject(er));
        } catch (er) {
            reject(er);
        }
    });
}

export const WebForm_DoCallback = async (
    eventTarget: any,
    eventArgument: any,
    eventCallback: any,
    context: any,
    errorCallback: any,
    useAsync: any,
    queryStrAdd: any
) => {
    return new Promise((resolve, reject) => {
        var postData =
            (window as any).__theFormPostData +
            "__CALLBACKID=" +
            (window as any).WebForm_EncodeCallback(eventTarget) +
            "&__CALLBACKPARAM=" +
            (window as any).WebForm_EncodeCallback(eventArgument);
        if ((window as any).theForm["__EVENTVALIDATION"]) {
            postData +=
                "&__EVENTVALIDATION=" +
                (window as any).WebForm_EncodeCallback((window as any).theForm["__EVENTVALIDATION"].value);
        }
        var xmlRequest: any;
        try {
            xmlRequest = new XMLHttpRequest();
        } catch (e) {
            try {
                xmlRequest = new (window as any).ActiveXObject("Microsoft.XMLHTTP");
            } catch (e) {}
        }
        var setRequestHeaderMethodExists = true;
        try {
            setRequestHeaderMethodExists = xmlRequest && xmlRequest.setRequestHeader;
        } catch (e) {}
        var callback: any = {};
        callback.eventCallback = eventCallback;
        callback.context = context;
        callback.errorCallback = errorCallback;
        callback.async = useAsync;
        var callbackIndex = (window as any).WebForm_FillFirstAvailableSlot(
            (window as any).__pendingCallbacks,
            callback
        );
        if (!useAsync) {
            if ((window as any).__synchronousCallBackIndex !== -1) {
                (window as any).__pendingCallbacks[(window as any).__synchronousCallBackIndex] = null;
            }
            (window as any).__synchronousCallBackIndex = callbackIndex;
        }
        if (setRequestHeaderMethodExists) {
            xmlRequest.onreadystatechange = () => {
                if (xmlRequest.readyState === 4) {
                    // if its complete
                    if (xmlRequest.status === 200) {
                        // if successful
                        (window as any).WebForm_CallbackComplete();
                        resolve(true);
                    } else {
                        reject(`xmlRequest failure`);
                    }
                }
            };
            callback.xmlRequest = xmlRequest;
            // e.g. http:
            var action = (window as any).theForm.action || document.location.pathname,
                fragmentIndex = action.indexOf("#");
            if (fragmentIndex !== -1) {
                action = action.substr(0, fragmentIndex);
            }
            action = action.split("?")[0] + (queryStrAdd || "");
            xmlRequest.open("POST", action, true);
            xmlRequest.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=utf-8");
            xmlRequest.send(postData);
            return;
        }
        callback.xmlRequest = {};
        var callbackFrameID = "__CALLBACKFRAME" + callbackIndex;
        var xmlRequestFrame = (document as any).frames[callbackFrameID];
        if (!xmlRequestFrame) {
            xmlRequestFrame = document.createElement("IFRAME");
            xmlRequestFrame.width = "1";
            xmlRequestFrame.height = "1";
            xmlRequestFrame.frameBorder = "0";
            xmlRequestFrame.id = callbackFrameID;
            xmlRequestFrame.name = callbackFrameID;
            xmlRequestFrame.style.position = "absolute";
            xmlRequestFrame.style.top = "-100px";
            xmlRequestFrame.style.left = "-100px";
            try {
                if ((window as any).callBackFrameUrl) {
                    xmlRequestFrame.src = (window as any).callBackFrameUrl;
                }
            } catch (e) {}
            document.body.appendChild(xmlRequestFrame);
        }
        var interval = window.setInterval(function () {
            xmlRequestFrame = (document as any).frames[callbackFrameID];
            if (xmlRequestFrame && xmlRequestFrame.document) {
                window.clearInterval(interval);
                xmlRequestFrame.document.write("");
                xmlRequestFrame.document.close();
                xmlRequestFrame.document.write(
                    '<html><body><form method="post"><input type="hidden" name="__CALLBACKLOADSCRIPT" value="t"></form></body></html>'
                );
                xmlRequestFrame.document.close();
                xmlRequestFrame.document.forms[0].action = (window as any).theForm.action;
                var count = (window as any).__theFormPostCollection.length;
                var element;
                for (var i = 0; i < count; i++) {
                    element = (window as any).__theFormPostCollection[i];
                    if (element) {
                        var fieldElement = xmlRequestFrame.document.createElement("INPUT");
                        fieldElement.type = "hidden";
                        fieldElement.name = element.name;
                        fieldElement.value = element.value;
                        xmlRequestFrame.document.forms[0].appendChild(fieldElement);
                    }
                }
                var callbackIdFieldElement = xmlRequestFrame.document.createElement("INPUT");
                callbackIdFieldElement.type = "hidden";
                callbackIdFieldElement.name = "__CALLBACKID";
                callbackIdFieldElement.value = eventTarget;
                xmlRequestFrame.document.forms[0].appendChild(callbackIdFieldElement);
                var callbackParamFieldElement = xmlRequestFrame.document.createElement("INPUT");
                callbackParamFieldElement.type = "hidden";
                callbackParamFieldElement.name = "__CALLBACKPARAM";
                callbackParamFieldElement.value = eventArgument;
                xmlRequestFrame.document.forms[0].appendChild(callbackParamFieldElement);
                if ((window as any).theForm["__EVENTVALIDATION"]) {
                    var callbackValidationFieldElement = xmlRequestFrame.document.createElement("INPUT");
                    callbackValidationFieldElement.type = "hidden";
                    callbackValidationFieldElement.name = "__EVENTVALIDATION";
                    callbackValidationFieldElement.value = (window as any).theForm["__EVENTVALIDATION"].value;
                    xmlRequestFrame.document.forms[0].appendChild(callbackValidationFieldElement);
                }
                var callbackIndexFieldElement = xmlRequestFrame.document.createElement("INPUT");
                callbackIndexFieldElement.type = "hidden";
                callbackIndexFieldElement.name = "__CALLBACKINDEX";
                callbackIndexFieldElement.value = callbackIndex;
                xmlRequestFrame.document.forms[0].appendChild(callbackIndexFieldElement);
                xmlRequestFrame.document.forms[0].submit();
            }
        }, 10);
    });
};
